import { SORT_STATE } from '@module/shared/commonTypes';

export interface ISiteModel {
    name: string;
    siteId: number;
    customer: string;
    region: string;
    servIsId: string;
    registered: boolean;
}

export const defaultSite: ISiteModel = {
    name: '',
    siteId: -1,
    customer: '',
    region: '',
    servIsId: '-1',
    registered: true
};

export interface IPagingSettings {
    skipItems: number;
    pageSize: number;
}

export interface ISortingSettings {
    sortField: string;
    sortDirection: SORT_STATE;
}

export interface ISitesState {
    sites: ISiteModel[];
    sitesLoading: boolean;
    pagingSettings: IPagingSettings;
    sortingSettings: ISortingSettings;
    totalNumberOfSites: number;
    searchFilter: string;
    selectedSite: ISiteModel;
    siteSelected: boolean;
    selectedSiteRegistered: boolean;
    siteRegister: {
        attempt: boolean;
        success: boolean;
        siteId: number;
    };
    fromServIs: boolean;
}
